// src/router/tiposOcorrencias.js

// Quem abre estas telas (TRI-107; o admin passa). Aplicado pelo guard de @/router/permissoes.js,
// que o menu lateral também usa.
const ROLES = ['coordenador_operacional']

const ocorrenciasBreadCrumb = [
    {
        label: 'Home',
        to: 'Home'
    },
    {
        label: 'Tipos de Ocorrências',
        to: 'TiposOcorrencias' //ajustar
    }
]

export default [
    {
        path: '/tipos-ocorrencias',
        name: 'TiposOcorrencias',
        component: () => import('@/views/TiposOcorrencias/TipoOcorrenciaListPage.vue'),
        meta: {
            roles: ROLES,
            title: 'Ocorrências',
            breadcrumb: ocorrenciasBreadCrumb 
        },
    },
    {
        path: '/tipos-ocorrencias/novo',
        name: 'TipoOcorrenciaNovo',
        component: () => import('@/views/TiposOcorrencias/NovoTipoOcorrenciaPage.vue'),
        meta: {
            roles: ROLES,
            title: 'Novo Tipo Ocorrência',
            breadcrumb: [
                ...ocorrenciasBreadCrumb, 
                {
                    label: 'Novo Tipo Ocorrência',
                    to: 'TipoOcorrenciaNovo'
                }
            ]
        }
    },
    {
        path: '/tipos-ocorrencias/:id/edit',
        name: 'TipoOcorrenciaEdit',
        component: () => import('@/views/TiposOcorrencias/NovoTipoOcorrenciaPage.vue'),
        meta: {
            roles: ROLES,
            title: 'Detalhes do tipo ocorrência',
            breadcrumb: [
                ...ocorrenciasBreadCrumb, 
                {
                    label: 'Novo Tipo Ocorrência',
                    to: 'TipoOcorrenciaNovo'
                }
            ]
        }
    }

];
